export default __webpack_public_path__ + "static/media/auction.9666158a.png";